import React from "react";

const NotFound = () => (
  <div className="container">
    <div className="form-row row">
      <div className="col-md-12 text-center not-found">
        <span className="display-1 d-block">404</span>
        <div className="mb-4 lead">
          The page you are looking for was not found.
        </div>
      </div>
    </div>
  </div>
);

export default NotFound;
